module.exports = __webpack_public_path__ + "img/Sign_11.9b0bf096.png";